import { Textarea as HeadlessTextarea } from '@headlessui/react';
import { ChangeEventHandler, forwardRef } from 'react';

interface Props {
  onChange: ChangeEventHandler<HTMLTextAreaElement>;
  name: string;
  rows: number;
  placeholder: string;
}

const Textarea = forwardRef<HTMLTextAreaElement, Props>((props, ref) => {
  const { onChange, name, placeholder, rows } = props;

  return (
    <HeadlessTextarea
      ref={ref}
      className="text-gray-800 shadow border-gray-200 w-full rounded-md"
      onChange={onChange}
      rows={rows}
      placeholder={placeholder}
      name={name}
    />
  );
});

// Add display name for better debugging
Textarea.displayName = 'Textarea';

export default Textarea;